import { render, staticRenderFns } from "./add-product-v2.modal.vue?vue&type=template&id=2607b1e3&scoped=true"
import script from "./add-product-v2.modal.vue?vue&type=script&lang=js"
export * from "./add-product-v2.modal.vue?vue&type=script&lang=js"
import style0 from "./add-product-v2.modal.vue?vue&type=style&index=0&id=2607b1e3&prod&lang=scss&scoped=true"
import style1 from "./add-product-v2.modal.vue?vue&type=style&index=1&id=2607b1e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2607b1e3",
  null
  
)

export default component.exports